export default __webpack_public_path__ + "static/media/arrow_forward_blue-tata-neu@2x.96f3d5e3.png";